export default __webpack_public_path__ + "static/ProValue_3@1200-b78efecbfef1b93754880e137bace9ec.webp";